// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import BoomBasketSwitchContainer from '../../modules/boom/components/BoomBasketSwitch/BoomBasketSwitchContainer';
import GRBasketSwitchContainer from '../../modules/gift-race/containers/GRBasketSwitchContainer';
import KLBasketSwitchContainer from '../../modules/koh-lanta/containers/KLBasketSwitchContainer';
import MissionBasketSwitchContainer from '../../modules/missions/components/MissionBasketSwitch/MissionBasketSwitchContainer';
import MPBasketSwitchContainer from '../../modules/monopoly/containers/MPBasketSwitchContainer';
import { BasketRow } from '../../styled-components/shared';
import BasketFreebetsSwitchContainer from '../BasketFreebetsSwitch/BasketFreebetsSwitchContainer';
import Checkbox from '../Checkbox';

const EligibleFreebetList = styled.div`
  display: flex;
  flex-direction: column;
`;

const EligibleFreebetListItem = styled.div`
  margin-bottom: 1em;

  &:last-of-type {
    margin-bottom: unset;
  }
`;

const StyledCheckBox = styled(Checkbox)`
  > div {
    border-radius: 2px;
    height: 1.2em;
    width: 1.2em;
  }
`;

const CardOddWrapper = styled.div`
  margin-top: ${({ $noMargin }) => ($noMargin ? '0em' : '0.5em')};
`;

const switchesSharedStyle = css`
  width: 100%;
`;

const StyledKLBasketSwitchContainer = styled(KLBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledGRBasketSwitchContainer = styled(GRBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledMissionBasketSwitchContainer = styled(MissionBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledMPBasketSwitchContainer = styled(MPBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledBoomBasketSwitchContainer = styled(BoomBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const FreebetSwitchContainer = styled(BasketFreebetsSwitchContainer)`
  ${switchesSharedStyle}
`;

type BasketCardEligibleFreebetsProps = {
  eligibleFreebets: {
    [key: string]: {
      freebetId: number;
      isUsed: boolean;
    };
  };
  isBasketSimpleMode: boolean;
  isBasketCombinedMode: boolean;
  nbItem: number;
  freebets: {
    [key: string]: {
      freebetId: number;
      amount: number;
      rule: string;
      freebetCodeId: string;
      title: string;
    };
  };
  oddId: number;
  handleCheckEligibleFreebets: (...params: unknown) => unknown;
  selectedFreebetId: number;
};

const BasketCardEligibleFreebets = ({
  eligibleFreebets,
  isBasketSimpleMode,
  isBasketCombinedMode,
  nbItem,
  freebets,
  oddId,
  handleCheckEligibleFreebets,
  selectedFreebetId,
}: BasketCardEligibleFreebetsProps) => {
  const eligibleFreebetsIds = eligibleFreebets ? Object.keys(eligibleFreebets) : [];
  const hasEligibleFreebets = eligibleFreebetsIds.length > 0;

  return hasEligibleFreebets ? (
    <EligibleFreebetList>
      {eligibleFreebetsIds.map((eligibleFreebetId) => {
        const currentFreebet = freebets?.[eligibleFreebetId];
        const amount = currentFreebet?.amount;
        const isUsed = eligibleFreebets[eligibleFreebetId].isUsed;

        return (
          <EligibleFreebetListItem key={eligibleFreebetId}>
            <StyledCheckBox
              checked={selectedFreebetId === parseInt(eligibleFreebetId, 10)}
              isDisabled={selectedFreebetId !== parseInt(eligibleFreebetId, 10) && isUsed}
              onCheckChange={handleCheckEligibleFreebets(amount, eligibleFreebetId)}
            >
              {currentFreebet?.title}
            </StyledCheckBox>
          </EligibleFreebetListItem>
        );
      })}
    </EligibleFreebetList>
  ) : (
    <CardOddWrapper $noMargin={(isBasketSimpleMode && nbItem === 1) || isBasketCombinedMode}>
      <BasketRow>
        <StyledGRBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledKLBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledMissionBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledMPBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledBoomBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <FreebetSwitchContainer itemId={oddId} />
      </BasketRow>
    </CardOddWrapper>
  );
};

export default React.memo<BasketCardEligibleFreebetsProps>(BasketCardEligibleFreebets);
